var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { takeUntil } from 'rxjs/operators';
var ViewScenePaginationComponent = /** @class */ (function () {
    // ---------- Lifecycle Events ----------
    function ViewScenePaginationComponent(viewService, layoutService, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.viewLayout = ViewLayout;
        this.nextChapterLabel = '';
        this.previousChapterLabel = '';
        this.ngUnsubscribe = new Subject();
    }
    ViewScenePaginationComponent.prototype.ngOnInit = function () {
        var _this = this;
        combineLatest(this.chapterIndex$, this.chapterCount$).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (_a) {
            var _b = __read(_a, 2), index = _b[0], count = _b[1];
            var previous = index > 0 ? index : 1;
            var next = index + 2 > count ? count : index + 2;
            _this.nextChapterLabel = "Next Chapter (" + next + " of " + count + ")";
            _this.previousChapterLabel = "Previous Chapter (" + previous + " of " + count + ")";
            _this.changeDetectorRef.markForCheck();
        });
    };
    ViewScenePaginationComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewScenePaginationComponent.prototype.isEnabled = function (layout) {
        return this.layoutService.isLayoutEnabled(layout);
    };
    // ---------- Interactions ----------
    ViewScenePaginationComponent.prototype.handleNextChapter = function () {
        this.viewService.nextChapter();
    };
    ViewScenePaginationComponent.prototype.handlePreviousChapter = function () {
        this.viewService.previousChapter();
    };
    __decorate([
        Select(StoryChaptersState.getSelectedChapterIndex),
        __metadata("design:type", Observable)
    ], ViewScenePaginationComponent.prototype, "chapterIndex$", void 0);
    __decorate([
        Select(StoryChaptersState.getChapterCount),
        __metadata("design:type", Observable)
    ], ViewScenePaginationComponent.prototype, "chapterCount$", void 0);
    return ViewScenePaginationComponent;
}());
export { ViewScenePaginationComponent };
